import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getPublication = async (dataOrigen, refrescar, api, token, body, config) => {
  
  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.publication.length <= 0 || data.startDate !== config.startDate || data.endDate !== config.endDate) {
    const response = await axios(configws)
    data = { publication: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  /* eslint-enable */

  const dataAsc = data.publication.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(publication => {

      return (
        (
          publication.user_id.toLowerCase().includes(queryLowered) ||
          publication.publications_datetime.toLowerCase().includes(queryLowered) ||
          publication.publications_pages.toLowerCase().includes(queryLowered)
        )
      )
  })

  return [
    200,
    {
      allData     : data.publication,
      total       : filteredData.length,
      publication : filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
      filterData  : filteredData
    }
  ]  
}

// ------------------------------------------------
// GET: Return list of publication
// ------------------------------------------------

let dataPublication = JSON.parse(localStorage.getItem("dataPublication")) || { publication: [], startDate: '', endDate: ''} 

mock.onGet('/apps/publication').reply(async config => {

  const user = getUserData()
  if (config.reset) {
    dataPublication = { publication: [], startDate: '', endDate: ''}
  }

  let user_id2 = user.usercoc.user_id

  if (config.report) {
    if (user.usercoc.role !== 1) {
      user_id2 = user.usercoc.user_id
    } else {
      if (config.user_id !== '') {
        user_id2 = config.user_id
      } else {
        user_id2 = ''
      }
    }
  }

  const body = {
    date_from : config.startDate,
    date_to   : config.endDate,
    user_id   : user_id2,
    usercoc   : user.usercoc.user_id
  }

  const result = await getPublication(dataPublication, 1, GetApiCOC('getlistPublications'), user.token, body, config)
  dataPublication = { publication: result[1].allData, startDate: config.startDate, endDate: config.endDate }

  localStorage.setItem("dataPublication", JSON.stringify(dataPublication))

  return result
})

// ------------------------------------------------
// Post: Add publication
// ------------------------------------------------
mock.onPost(/\/api\/publications\/\d+/).reply(async config => {

  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('insertPublications'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// Post: Edit Publication
// ------------------------------------------------
mock.onPost(/\/api\/publicationsEdit\/\d+/).reply(async config => {

  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('updatePublications'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})